import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import {
  CodeEditor,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@elementary/common-ui/components';
import useSelectedWarehouseType from 'shared/hooks/useSelectedWarehouseType';

const TabContainer = styled(Stack)`
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.palette.common.gray14};
  border-radius: 8px;
  gap: 16px;
  overflow: auto;
  max-height: 600px;
`;

const QueryAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    height: auto;
    min-height: 48px;
    padding: 12px 16px;
  }
`;

const QueryAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`;

type Props = {
  queries?: string[] | null;
};

const BiQueriesTabContent = ({ queries }: Props) => {
  const warehouseType = useSelectedWarehouseType();

  if (!queries || queries.length === 0) {
    return (
      <TabContainer>
        <Typography>No queries found</Typography>
      </TabContainer>
    );
  }

  return (
    <TabContainer>
      {queries.map((query, index) => (
        <Accordion key={index} defaultExpanded={index === 0}>
          <QueryAccordionSummary>
            <Typography variant="subtitle2">Query {index + 1}</Typography>
          </QueryAccordionSummary>
          <QueryAccordionDetails>
            <CodeEditor
              value={query}
              mode="sql"
              warehouseType={warehouseType}
              readOnly
              height="300px"
            />
          </QueryAccordionDetails>
        </Accordion>
      ))}
    </TabContainer>
  );
};

export default BiQueriesTabContent;
